<template>
	<v-container>
		<h1>Welcome to the report center!</h1>
		<v-alert class="logoutAlert" type="warning" v-show="contactAdminVisible">
			{{ txt.contactAdmin }}
		</v-alert>
		<card-grid :contents="gridContents"/>
	</v-container>
</template>

<script>
import axios from 'axios'
import CardGrid from './CardGrid.vue'

export default {
	components: { CardGrid },
	data() {
		return {
			gridContents: [],
			contactAdminVisible: false,
			txt: {
				contactAdmin: `You seem to be new here. To get permission to see 
						the reports, please contact report-center@alturos.com!`,
			},
		}
	},
	methods: {
		async getApps() {
			try {
				// eslint-disable-next-line no-undef
				const r = await axios.get(`${config.baseAPIurl}/dashboard/application`)

				this.gridContents = r.data
				if (r.data.length === 0) this.contactAdminVisible = true
				else this.contactAdminVisible = false

				this.gridContents.forEach((el) => {
					el.appDescription = el.appdescription
					el.appName = el.appname
					el.appNameShort = el.appnameshort
					el.iconLink = el.iconlink

					delete el.iconlink
					delete el.appnameshort
					delete el.appname
					delete el.appdescription
				})
			} catch (e) {
				console.log(e)
			}
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.getApps()
		})
	},
}
</script>

<style>

</style>
